<style scoped>
  .knowledge-iframe{width: 100%;min-height:700px;border: none}
</style>

<template>
  <div>
    <iframe class="knowledge-iframe" :src="URL"></iframe>
  </div>
</template>

<script>
  export default {
    name: "mdPage",
    data(){
      return{
        URL:'about:blank'
      }
    },
    methods:{
      getURL:function(){
        var _this = this
        _this.send({
          headers:'To/ApplyConnect',
          success:function(res){
            _this.URL = 'https://fc.yunlianlaw.cn/contractcenter?access_token='+res.access_token
          }

        })
      }
    },
    mounted:function(){
      this.getURL()
    },
    computed:{
      userId:function () {
        return window.sessionStorage.userId
      },
    }
  }
</script>